import { useNavigate } from "react-router-dom";
import { CountryBadge } from "../common/helper";

const countries = [
  { color: "bg-emerald-500", label: "India" },
  { color: "bg-red-500", label: "Canada" },
  { color: "bg-blue-600", label: "USA" },
];

export default function HeroSection() {
  const navigate = useNavigate();
  return (
    <header className="relative min-h-[60vh] flex items-center overflow-hidden pt-10 md:pt-20">

      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuDKclQae30T0JgoDZCYx1dDFpKiMg8XeJ739yTPa59r0TSg6rexSWGgV6kMJWA4ZMk2TZc2oprYkcbp_EJD7OOa8YXBZlALFiVrd3gnVgtXxOYddL5qgSXTyjeGIukh8K0aEcQd7IbT5r5kLzGV1mA37M6xljffwN1cT4xTf_GZ-bDCWvPXQAGgZvX1w5_vWb-N_kJWPBsqRLbSrblmwf5eecXEERiunUvbNXI3MvuCEn5C5CC0DYqUqlah6KIzvCGi-B29J1k_ADZO"
          alt="Office"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-white/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-12">
        <div className="max-w-xl">

          {/* Tag */}
          <span className="text-xs font-semibold tracking-widest uppercase text-[#A67C00] mb-3 block">
            Premium Financial Services
          </span>

          {/* Heading */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-[#0A1F44] mb-5">
            Trusted Accounting & Tax Expertise Across India, Canada & USA
          </h1>

          {/* Subtext */}
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-8">
            17+ years helping SMEs stay compliant, optimize taxes, and scale globally without financial chaos.
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="bg-[#D4A017] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:shadow-lg hover:-translate-y-[1px] transition-all">
              Get Free Consultation
            </a>

            <a
              href="#services"
              className="border border-[#0A1F44] text-[#0A1F44] px-6 py-3 rounded-lg font-semibold hover:bg-[#0A1F44] hover:text-white transition-all">
              View Services
            </a>
          </div>

          {/* Countries */}
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {countries.map((c) => (
              <CountryBadge key={c.label} color={c.color} label={c.label} />
            ))}
          </div>

        </div>
      </div>
    </header>
  );
}